"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwPodGridColumn = _interopRequireDefault(require("./CwPodGridColumn.scss"));

var CwPodGridColumn = function CwPodGridColumn(props) {
  return _react.default.createElement("div", {
    className: props.gwtStandalonePod ? _CwPodGridColumn.default.podGridColumnGwt : _CwPodGridColumn.default.podGridColumn
  }, props.children);
};

CwPodGridColumn.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element]),
  gwtStandalonePod: _propTypes.default.bool
};
var _default = CwPodGridColumn;
exports.default = _default;